import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header";
import AisprawlSidebar from "./AisprawlSidebar";
import { useSidebar } from "../../App";
import "../../styles/theme.css";
import "../../styles/dashboard.css";

export default function AisprawlLayout() {
  const { sidebarCollapsed } = useSidebar();

  return (
    <div className="theme-whbl">
      <Header />
      <div className="container-fluid">
        <div className="main-container">
          <div className={`${sidebarCollapsed ? 'col-1' : 'col-2'} p-0`}>
            <AisprawlSidebar />
          </div>
          <main
            className={`${sidebarCollapsed ? 'col-11' : 'col-10'}`}
            style={{ width: "100%", overflowX: "auto" }}
          >
            <div className="dashboard">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
